"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionAliases = exports.Actions = void 0;
const CREATE = "create";
const READ = "read";
const UPDATE = "update";
const DELETE = "delete";
const ARCHIVE = "archive";
const IMPORT = "import";
const AUGMENT = "augment";
const Actions = {
    CREATE,
    READ,
    UPDATE,
    DELETE,
    ARCHIVE,
    IMPORT,
    AUGMENT,
};
exports.Actions = Actions;
const ActionAliases = {
    "READ_ONLY": [READ],
    "CREATE_ONLY": [CREATE],
    "CRUD": [CREATE, READ, UPDATE, AUGMENT, DELETE],
    "CRU": [CREATE, READ, UPDATE, AUGMENT],
    "CR": [CREATE, READ],
    "RUD": [READ, UPDATE, AUGMENT, DELETE],
    "RU": [READ, UPDATE, AUGMENT],
    "NONE": [],
};
exports.ActionAliases = ActionAliases;
